const getMainContentId = () => 'salv-main-content';

export default { getMainContentId };
